/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

import moment from "moment-jalaali";

const getters = {

  menuItems: state => {

    if (state.AppActiveUser.role === 'MODERATOR') {
      return [
        {
          url: "/",
          name: "صفحه ی اصلی",
          slug: "home",
          icon: "HomeIcon",
        },
        {
          url: "/tasks",
          name: "کارگروه ها",
          slug: "tasks",
          icon: "CreditCardIcon",
        },
        {
          url: "/students",
          name: "دانش آموزان",
          slug: "students",
          icon: "UsersIcon",
        },
        {
          url: "/drivers",
          name: "رانندگان",
          slug: "drivers",
          icon: "NavigationIcon",
        },
        {
          url: null,
          name: "مدیریت افراد",
          icon: "UserPlusIcon",
          submenu: [
            {
              url: "/students/create",
              name: "افزودن دانش آموز",
              slug: "students-create",
              icon: "HomeIcon",
            },
            {
              url: "/drivers/create",
              name: "افزودن راننده",
              slug: "drivers-create",
              icon: "HomeIcon",
            }
          ]
        },
        {
          url: null,
          name: "مدیریت پیام ها",
          icon: "MailIcon",
          submenu: [
            // {
            //   url: "/received_messages",
            //   name: "پیام های دریافت شده",
            //   slug: "received_messages",
            //   icon: "HomeIcon",
            // },
            {
              url: "/sent_messages",
              name: "پیام های ارسال شده",
              slug: "sent_messages",
              icon: "HomeIcon",
            },
            {
              url: "/send_message",
              name: "ارسال پیام",
              slug: "send_message",
              icon: "HomeIcon",
            }
          ]
        },
        {
          url: "/cohorts",
          name: "مدیریت گروه ها",
          slug: "cohorts",
          icon: "GridIcon",
        },
      ]
    } else if (state.AppActiveUser.role === 'STUDENT') {
      return [
        {
          url: "/",
          name: "صفحه ی اصلی",
          slug: "home",
          icon: "HomeIcon",
        },
        {
          url: "/profile",
          name: "پروفایل",
          slug: "profile",
          icon: "UserIcon",
        },
        {
          url: "/received_messages",
          name: "پیام ها",
          slug: "received_messages",
          icon: "MailIcon",
        }
      ]
    }else if (state.AppActiveUser.role === 'DRIVER') {
      return [
        {
          url: "/",
          name: "صفحه ی اصلی",
          slug: "home",
          icon: "HomeIcon",
        },
        {
          url: "/profile",
          name: "پروفایل",
          slug: "profile",
          icon: "UserIcon",
        },
        {
          url: "/received_messages",
          name: "پیام ها",
          slug: "received_messages",
          icon: "MailIcon",
        }
      ]
    }
  },
  userCredentials: state => {
    return {
      userName: state.AppActiveUser.userName,
      password: state.AppActiveUser.password
    }
  },
  userRole: state => {
    if (state.AppActiveUser.role === 'MODERATOR')
      return 'اپراتور'
    else if (state.AppActiveUser.role === 'STUDENT')
      return 'دانش آموز'
    else if (state.AppActiveUser.role === 'DRIVER')
      return 'راننده'

  },
  userDisplayName: state => {
    return state.AppActiveUser.firstName + ' ' + state.AppActiveUser.lastName
  },
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  taskInfoDrivers: state => {
    if (state.taskInfo.id) {

      let drivers = []
      state.taskInfo.services.forEach((serviceInfo, serviceIndex) => {
        const _driver = Object.assign({}, serviceInfo.driver);
        if (_driver) {
          _driver['serviceIndex'] = serviceIndex
          drivers.push(_driver)
        }
      })

      return drivers
      // return state.taskInfo.services
      //   .filter(i => i.driver)
      //   .map(s => {
      //     s.driver['serviceIndex'] = i
      //   })
    }
    return [];
  },
  taskInfoStudents: state => {
    if (!state.taskInfo.id)
      return [];
    let students = []
    state.taskInfo.services.forEach((serviceInfo) => {
      serviceInfo.serviceMember.forEach(member => {
        students.push(member)
      })
    })
    return students.map(i => {
      return {
        id: i.id,
        name: i.firstName + ' ' + i.lastName,
        image: i.imagePath
      }
    });
  },
  taskInfoServices: state => {
    if (state.taskInfo.id) {
      return state.taskInfo.services;
    }
    if (state.task.members.length)
      return [];
  },
  driversGeo: (state, getters) => {
    let taskInfoDeviceIds = getters.taskInfoDrivers
      .map(i => {
        return Number(i.deviceId)
      })
      .filter(Boolean)


    return state.positions
      .filter(i => taskInfoDeviceIds.includes(i.deviceId))
      .map(i => {
        let driver = getters.taskInfoDrivers.find(d => d.deviceId == i.deviceId);
        return {
          "type": "Feature",
          "properties": {
            driver: driver.firstName + ' ' + driver.lastName,
            speed: i.speed.toFixed(2),
            serviceIndex: driver.serviceIndex,
          },
          "geometry": {
            "type": "Point",
            "coordinates": [i.longitude, i.latitude]
          }
        }
      })
  },
  studentsGeo: state => {
    if (!state.taskInfo.id)
      return [];
    let students = []
    state.taskInfo.services.forEach((serviceInfo, serviceIndex) => {
      serviceInfo.serviceMember.forEach(member => {
        students.push({
          "type": "Feature",
          "properties": {
            student: member.firstName + ' ' + member.lastName,
            serviceId: serviceInfo.id,
            serviceIndex: serviceIndex,
          },
          "geometry": {
            "type": "Point",
            "coordinates": [member.taskLocationLatLong.longitude, member.taskLocationLatLong.latitude]
          }
        })
      })
    })
    return students;
  },
  unReadMessages: state => {
    return state.receivedMessages.filter(i => !i.readTime)
  }
}

export default getters
